module.exports = __webpack_public_path__ + "static/media/Group237656.3bd86f37.webp";